module.exports = __webpack_public_path__ + "img/mascara-mobile.149a0172.png";